import queryString from 'query-string';
import { getEnv, getKrnDomain } from '../api';
import { Max_Route_Count, getAppProps, getNavigation } from '@/Navigation';
import { getCurrentContainerType } from '../bridge/getCurrentContainerType';
import { getUrlPathname } from '../url';

export async function isHitSpaAB() {
    // try {
    //     // 获取SPA AB结果
    //     const result = await firstScreenAbInfo;
    //     console.log('spa ab result: ', result);
    //     return !!result?.krn_spa?.value;
    // } catch (e) {
    //     return false;
    // }

    return false;
}

const buildSpaUrl = (targetUrl) => {
    const parseUrl = queryString.parseUrl(targetUrl);
    const urlQuery = parseUrl.query;
    const redirectUrl = urlQuery.redirectUrl as string;
    let mergedQuery: any = {};
    // 解析一码多投链路中的参数
    if (redirectUrl) {
        const redirectUrlQuery = queryString.parseUrl(redirectUrl).query;
        mergedQuery = Object.assign({}, urlQuery, redirectUrlQuery);
    }
    const pathname = getUrlPathname(parseUrl.url);
    // MPA路由pathname到SPA路由名字的映射关系
    const routePath2NameMap = {
        '/krn-web/detail': 'Detail',
        '/krn-web/order-confirm': 'OrderConfirm',
        '/krn-web/order-detail': 'OrderDetail',
        '/krn-web/my-shopping-car': 'MyShoppingCar',
        '/krn-web/recommend-goods': 'RecommendGoods',
        // .html
        '/krn-web/detail.html': 'Detail',
        '/krn-web/order-confirm.html': 'OrderConfirm',
        '/krn-web/order-detail.html': 'OrderDetail',
        '/krn-web/my-shopping-car.html': 'MyShoppingCar',
        '/krn-web/recommend-goods.html': 'RecommendGoods',
    };
    // SPA模式下要修改之前的路径
    const componentName = routePath2NameMap[pathname];
    if (componentName) {
        // 跳转到SPA Bundle
        mergedQuery.componentName = componentName;
        const url = queryString.stringifyUrl(
            {
                url: `${getKrnDomain()}${pathname}`,
                query: {
                    // 老url中的参数
                    ...mergedQuery,
                    env: getEnv(),
                    krnFollowParams: 1,
                    redirectUrl: queryString.stringify(
                        {
                            // 参数拼接两遍吧，防止低版本不支持krnFollowParams
                            ...mergedQuery,
                            // 删除部分无用的，防止url不可读或重复拼接
                            __launch_options__: null,
                            krnUselessUrl: null,
                            degradeWebUrl: null,
                            redirectUrl: null,
                            bundleId: 'EcommSpaBundle',
                            componentName,
                        },
                        { skipNull: true, skipEmptyString: true },
                    ),
                    // 删除部分无用的，防止url不可读
                    krnUselessUrl: null,
                    degradeWebUrl: null,
                },
            },
            { skipNull: true, skipEmptyString: true },
        );
        console.log('将MPA路径改成SPA路径：', url);
        return { spaUrl: url, componentName, query: mergedQuery };
    }
    return { spaUrl: targetUrl, componentName, query: {} };
};

/**
 * 将MPA地址转换成SPA地址
 */
export async function covertToSpaUrl({
    targetUrl,
    targetContainerType,
}: {
    // 目标url
    targetUrl: string;
    // 目标容器类型
    targetContainerType: 'fullScreen' | 'halfScreen' | 'auto';
}): Promise<{
    // 是否是SPA Url，一些H5地址不能被转成KRN SPA地址
    isSpaUrl: boolean;
    options: {
        // 用于MPA容器跳转
        url: string;
        // 是否使用新容器打开
        openNewContainer: boolean;
        // 用于SPA路由跳转
        navigationOptions: {
            // 要路由的组件名字
            componentName: string;
            // 要路由的参数
            query: object;
        };
    };
}> {
    // 判断是否命中SPA AB
    const isSpaAB = await isHitSpaAB();
    if (!isSpaAB) {
        return {
            isSpaUrl: false,
            options: {
                url: targetUrl,
                openNewContainer: true,
                navigationOptions: {
                    componentName: '',
                    query: {},
                },
            },
        };
    }

    const { componentName, spaUrl, query } = buildSpaUrl(targetUrl);
    if (componentName) {
        let openNewContainer = false;
        const currContainerType = await getCurrentContainerType();
        // 购物车吸底、吸顶比较复杂，必须用全屏容器打开，暂时不考虑半屏拖全屏容器
        if (componentName === 'MyShoppingCar') {
            if (currContainerType === 'halfScreen') {
                openNewContainer = true;
            }
        }
        // 当前容器和目标容器类型不一致，用新容器打开
        else if (targetContainerType !== 'auto' && targetContainerType !== currContainerType) {
            openNewContainer = true;
        }

        const routeLength = getNavigation()?.getRootState()?.routes?.length ?? 0;
        // 使用SPA的方式打开
        if (routeLength >= Max_Route_Count) {
            openNewContainer = true;
        }

        if (getAppProps().bundleId !== 'EcommSpaBundle') {
            openNewContainer = true;
        }

        return {
            isSpaUrl: true,
            options: {
                // 用于MPA容器跳转
                url: spaUrl,
                openNewContainer,
                // 用户SPA路由跳转
                navigationOptions: {
                    componentName,
                    query,
                },
            },
        };
    }
    return {
        isSpaUrl: false,
        options: {
            // 用于MPA容器跳转
            url: targetUrl,
            openNewContainer: true,
            // 用户SPA路由跳转
            navigationOptions: {
                componentName,
                query,
            },
        },
    };
}
